import styled from "styled-components";

export const DoubleInput = styled.div`
    display: flex;
    align-items: center;
    margin: 4rem 0;
`